module.exports = __webpack_public_path__ + "img/full2-min.d59841c6.png";